const styles = {
	wrapper: {
		padding: 30,
		marginBottom: 30,
		borderRadius: 6,
		backgroundColor: 'white',
		':last-child': {
			marginBottom: 0,
		},
		h3: {
			color: 'primary',
			fontSize: ['17px', 2],
		},
	},
	header: {
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: [20, 30],
	},
};

export default styles;
